import {useLayoutEffect, useState} from '@wordpress/element'

export default function useViewport() {
  const [isMobile, setIsMobile] = useState<boolean>()

  useLayoutEffect(() => {
    const width = window.innerWidth
    setIsMobile(width < 1280)

  }, [])

  return { isMobile }
}